/*
 * @FilePath: /netHallOfficialAccounts/src/views/Home/components/business.js
 */

import myWater_Second from '@/assets/icon/ic_blue_充值缴费@2x.png';
import myWater_Third from '@/assets/icon/ic_blue_电子发票@2x.png';
import myWater_Fourth from '@/assets/icon/ic_blue_用水统计@2x.png';
import myWater_Fifth from '@/assets/icon/ic_blue_用户绑定@2x.png';
import myWaterOutlets from '@/assets/icon/ic_营业网点_蓝.png';
import myWater_Golden_Second from '@/assets/icon/ic_golden_充值缴费@2x.png';
import myWater_Golden_Third from '@/assets/icon/ic_golden_电子发票@2x.png';
import myWater_Golden_Fourth from '@/assets/icon/ic_golden_用水统计@2x.png';
import myWater_Golden_Fifth from '@/assets/icon/ic_golden_用户绑定@2x.png';
import myWaterOutletsReal from '@/assets/icon/ic_营业网点_金.png';

import business_First from '@/assets/icon/ic_用水报装@2x.png';
import business_Second from '@/assets/icon/ic_过户更名@2x.png';
import business_Name from '@/assets/icon/ic_name.png';
import business_Change from '@/assets/icon/ic_change.png';

const girdIcon = [
    {
      name: '用户信息',
      icon: myWater_Fourth,
      pathUrl: '/WaterStatistics',
      componentName: 'WaterStatistics',
    },
    { name: '电子发票', icon: myWater_Third, pathUrl: '/Invoice', componentName: 'Invoice' },
    {
        name: '充值缴费',
        icon: myWater_Second,
        pathUrl: '/QueryPay',
        componentName: 'QueryPay',
    },
    { name: '用户绑定', icon: myWater_Fifth, pathUrl: '/Bind', componentName: 'Bind' },
    {
        name: '附近终端',
        icon: myWaterOutlets,
        pathUrl: '/PublicNews/BusinessOffice',
        componentName: 'BusinessOffice',
    }
];

const girdGoldenIcon = [
    {
      name: '用户信息',
      icon: myWater_Golden_Fourth,
      pathUrl: '/WaterStatistics',
      componentName: 'WaterStatistics',
    },
    {
      name: '电子发票',
      icon: myWater_Golden_Third,
      pathUrl: '/Invoice',
      componentName: 'Invoice',
    },
    {
      name: '附近终端',
      icon: myWaterOutletsReal,
      pathUrl: '/PublicNews/BusinessOffice',
      componentName: 'BusinessOffice',
    },
    {
        name: '充值缴费',
        icon: myWater_Golden_Second,
        pathUrl: '/WaterAccount/PreStorage',
        componentName: 'PreStorage',
    },
    { name: '用户绑定', icon: myWater_Golden_Fifth, pathUrl: '/Bind', componentName: 'Bind' },
];

const businessIcon = [
    { name: '变更户名', icon: business_Name, pathUrl: '/Business/RenamedNotice' },
    { name: '变更手机号码', icon: business_Second, pathUrl: '/Business/NewsTurnNotice' },
    { name: '用水报装', icon: business_First, pathUrl: '/Business/Expand' },
    { name: '自主开户', icon: business_Change, pathUrl: '/PersonInstall/PersonInstall' },
   ];
export { girdIcon, girdGoldenIcon, businessIcon };
